import { render, staticRenderFns } from "./AssetSubCategories.vue?vue&type=template&id=0218fc92&scoped=true&"
import script from "./AssetSubCategories.vue?vue&type=script&lang=ts&"
export * from "./AssetSubCategories.vue?vue&type=script&lang=ts&"
import style0 from "./AssetSubCategories.vue?vue&type=style&index=0&id=0218fc92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218fc92",
  null
  
)

export default component.exports